import { RiCodeSSlashLine, RiLinkM, RiListSettingsLine } from 'react-icons/ri';
import React, { useEffect, useState } from 'react';
import SetupTab from './setup/SetupTab';
import RedirectsTab from './redirects/RedirectsTab';
import PostbacksAndRouting from './postbacks-and-routing/PostbacksAndRouting';
// import SurveysTab from './surveys/SurveysTab';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Tabs } from '../../../../components/UiComponents/Ui';

const SupplierTabs = ({ supplierID }) => {
  const { id, type } = useParams();
  const initialTab = type || 'setup';
  const [tab, setTab] = useState(initialTab);
  const navigate = useNavigate();

  const tabAccess = {
    setup: true,
    surveys: true,
    redirects: true,
    'postbacks-and-routing': true,
    contacts: true,
    logs: true,
  };

  const supplierTabs = [
    {
      label: 'Setup',
      icon: <RiListSettingsLine size={20} />,
      value: 'setup',
      show: tabAccess.setup,
    },
    // { label: 'Surveys', icon: <RiFileListLine size={20} />, value: 'surveys', show: tabAccess.surveys },
    {
      label: 'Redirects',
      icon: <RiLinkM size={20} />,
      value: 'redirects',
      show: tabAccess.redirects,
    },
    {
      label: 'Postbacks & Routing',
      icon: <RiCodeSSlashLine size={20} />,
      value: 'postbacks-and-routing',
      show: tabAccess['postbacks-and-routing'],
    },
    // { label: 'Contacts', icon: <RiContactsBookLine size={20} />, value: 'contacts', show: tabAccess.contacts },
    // { label: 'Logs', icon: <RiFileList3Line size={20} />, value: 'logs', show: tabAccess.logs },
  ];

  const panels = {
    setup: <SetupTab supplierID={supplierID} />,
    // surveys: <SurveysTab supplierID={supplierID} />,
    redirects: <RedirectsTab supplierID={supplierID} />,
    'postbacks-and-routing': <PostbacksAndRouting supplierID={supplierID} />,
    // logs: <LogsTab supplierID={supplierID} />,
  };

  const handleTabChange = (newValue) => {
    setTab(newValue);
    navigate(`/suppliers/${id}/${newValue}`);
  };

  useEffect(() => {
    if (tab && !tabAccess[tab]) {
      setTab(
        Object.keys(tabAccess).find((item) => Boolean(tabAccess[item])) || '',
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialTab]);

  return (
    <div className="h-full space-y-6">
      <Tabs
        variant="box"
        ariaLabel="Supplier tabs"
        value={tab}
        onChange={handleTabChange}
        items={supplierTabs
          .filter((t) => Boolean(t.show))
          .map(({ label, value, icon }) => ({ label, value, icon: icon }))}
      />
      {tabAccess[tab] ? panels[tab] : null}
    </div>
  );
};

export default SupplierTabs;
